module.exports = __webpack_public_path__ + "img/caselist3.cd0bc9eb.jpg";